import axiosIns from '@/libs/axios'

const ROOT_URL = '/indicators'

export default {
  namespaced: true,
  state: {
    summary: {
      overview: {},
      byDecisionModule: [],
      byFamily: [],
      recent: [],
      filters: {},
    },
    filters: {
      market: 'FUTURES',
      hours: 72,
      family: '',
      limit: 40,
    },
    loading: false,
  },
  getters: {
    summary: state => state.summary,
    filters: state => state.filters,
    loading: state => state.loading,
  },
  mutations: {
    SET_SUMMARY(state, summary) {
      state.summary = {
        overview: {},
        byDecisionModule: [],
        byFamily: [],
        recent: [],
        filters: {},
        ...(summary || {}),
      }
    },
    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...(filters || {}) }
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
  },
  actions: {
    fetch({ commit, state }, params) {
      commit('SET_LOADING', true)
      const nextFilters = {
        market: params?.market || state.filters.market || 'FUTURES',
        hours: Number(params?.hours || state.filters.hours || 72),
        family: (params?.family || state.filters.family || '').trim(),
        limit: Number(params?.limit || state.filters.limit || 40),
      }
      commit('SET_FILTERS', nextFilters)
      return axiosIns.post(`${ROOT_URL}/signal-outcomes/summary`, {
        market: nextFilters.market,
        hours: nextFilters.hours,
        family: nextFilters.family || undefined,
        limit: nextFilters.limit,
      })
        .then(response => {
          commit('SET_SUMMARY', response.data.data || {})
          return response.data.data
        })
        .finally(() => commit('SET_LOADING', false))
    },
  },
}
